// NIKA (owner, 2026-08-13) — **THE ONE MARK THAT SAYS A READING'S WORDS NEVER ARRIVED, DRAWN ON
// EVERY SURFACE THAT OFFERS THAT READING.**
//
// HER REPORT was a SPLIT TRUTH: the Shelves drawer and My Room disagreed about what she owns. They
// could disagree because each surface decided for itself what "she has this reading" means, and
// neither of them could see the one fact that settles it. So the mark is a COMPONENT rather than a
// sentence typed at two call sites — the same ruling `PreviousDetailsBadge` (R34) is built on, and
// for the same reason: two copies of a member-facing sentence is two answers to one question
// (R28/R29), and the copy that drifts is the one nobody is looking at.
//
// **IT RENDERS NOTHING WHEN THE READING IS WRITTEN, AND THAT IS THE LOAD-BEARING HALF.** 1,959 saved
// rows carry no `interpreted` key at all and every one of them is a complete reading, so a badge
// that drew on absence would tell almost every member her whole shelf was broken. The decision is
// `readingIsWritten`'s and is never re-made here — this component asks the law and draws.
//
// **THE TITLE IS THE SENTENCE, AND IT DOES NOT SAY "TEMPORARILY".** `ReportView` has always carried
// a note reading *"Written interpretations are temporarily unavailable"* — true the minute a chart
// was cast and false ever since, because nothing re-runs one. 229 charts have worn it for days.
// D-1/D-4's ruling, word for word: advice that is a lie for a run that will never happen again is
// worse than no advice. This says what is true (the placements are real, the writing is not there)
// and points at the thing that fixes it.
import { readingIsWritten } from "../lib/room-reports";

export function UnwrittenBadge({ interpreted }: { interpreted?: boolean | null }) {
  if (readingIsWritten(interpreted)) return null;
  return (
    <span
      className="unwritten-mark"
      title="Your placements are calculated and saved. The written reading did not come through when this was cast — open it and tap Write it now."
    >
      writing did not come through
    </span>
  );
}
